import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  FormArray,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ip } from 'src/app/constant/constant';
import { staticFieldLabels } from 'src/app/constant/staticfieldlabels';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { CityEnterDeletemodelComponent } from 'src/app/modal/deletemodel/deletemodel.component';
import { MapService } from 'src/app/services/map.service';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { RetirecharacterComponent } from '../modals/retirecharacter/retirecharacter.component';
import { AiGenerationComponent } from '../modals/ai-generation/ai-generation.component';
import { DeleteGameAndCharacterModalComponent } from '../../game-master-detail/delete-character-modal/delete-character-modal.component';
import { CommonCharacterImageUploadModalComponent } from '../../shared/common-character-image-upload-modal/common-character-image-upload-modal.component';
import { CanComponentDeactivate } from './can-deactive-guard/guards/unsaved-changes.guard';
import { catchError, combineLatest, distinctUntilChanged, filter, map, Observable, of, startWith, Subscription, switchMap, take, tap, debounceTime } from 'rxjs';
import { MapDataService } from 'src/app/services/map-data.service';
import { WikiService } from 'src/app/services/wiki.service';
import { WikiApiService } from '../../wiki/services/wiki-api.service';
import { CityMapService } from 'src/app/services/city-map.service';
import { layerlist } from 'src/app/constant/maplayers';
import { SubscriptionStatus } from '../../subscription/models/subscription-usage.model';
import { InviteConfirmationModalComponent } from '../../invitationpage/invitation-detailpage/confirmation-modal/invite-confirmation-modal.component';

declare var $: any; // Declare jQuery

@Component({
    selector: 'app-player-detail',
    templateUrl: './player-detail.component.html',
    styleUrls: ['./player-detail.component.scss'],
    standalone: false
})
export class PlayerDetailComponent
  implements OnInit, AfterViewInit, OnDestroy, CanComponentDeactivate {
  playerdetailform: FormGroup;
  playerdata: any;
  nick_name: any;
  mode: any;
  playerId: any;
  showRequiredFields: boolean = false; // Declare the showRequiredFields property here
  requiredFields: string[] = [];
  staticFieldLabels = staticFieldLabels;
  isClassAdded = false;
  planUsage: SubscriptionStatus | null = null;
  productlist: any;
  image_url = ip;
  raceList: any;
  Classlist: any;
  alignmentlist: any;
  tattoos_scars_piercings_options: any = [
    {
      value: 'tattoo',
      detail: 'Tattoo',
    },
    {
      value: 'scar',
      detail: 'Scar',
    },
    {
      value: 'piercing',
      detail: 'Piercing',
    },
  ];
  hairList: any;
  Sexlist: any;
  Pronounslist: any;
  Buildlist: any;
  walking_gate_list: any;
  game_details: any;
  title_list: any;
  physical_list: any;
  clothing_list: any;
  hat_list: any;
  mantle_list: any;
  sexualorientation_list: any;
  wealth_list: any;
  temperament_list: any;
  emotionalstate_list: any;
  educationlist: any;
  eye_list: any;
  base64Cropped: string = '';
  ears_list: any;
  cloak_list: any;
  clothingconditionlist: any;
  socialtraitlist: any;
  maladaptivelist: any;
  dysfunctionalsocialtraitlist: any;
  emotional_trait_list: any;
  moraltrait: any;
  maladaptivetraitlist: any;
  beard_list: any;
  base64Regular: any;
  mount_list: any;
  familiar_list: any;
  uploadedimage: any;
  selectedimage: any;
  coords: any;
  game_id: number;
  user_id: any;
  map_code: string = '';
  @ViewChild('map', { read: ElementRef, static: true }) mapElement: ElementRef;
  mapListData: any[] = [];
  listofRemoveCharacters: any;
  minValue: number = 0;
  maxValue: number = 50;
  maxRows: number = 5;
  personal_economic_status: any;
  primary_class_list: any;
  postures: any;
  body_shapes: any;
  personal_social_status: any;
  foundational_learning: any;
  apprentice_training: any;
  scholarly_studies: any;
  guild_memberships: any;
  skin_texture_list: any;
  facial_hair_list: any;
  pet_familiar_mount_list: any;
  styletruefalse: boolean = false;
  leaning_towards: any;
  motivation_list: any;
  inspiration_list: any;
  loyalty_list: any;
  guiding_principle_list: any;
  filter_motivation: any;
  filter_inspiration: any;
  filter_loyalties: any;
  filter_guiding_principles: any;
  coordSubscription: Subscription;
  activePath: string;
  creating: boolean = false;
  cityClick: boolean = false;
  cityMapVisibleSubscription: Subscription;
  @ViewChild('cityMap') cityMap: ElementRef;
  birthLocation: {
    culture: string;
    religion: string;
    province: string;
    city: string;
    state: string;
  } = {
      culture: '',
      religion: '',
      province: '',
      city: '',
      state: '',
    };
  newLayers: any;
  layerlist = layerlist;
  acceptbtn: boolean = false;
  playerLevel: any;
  playerOuterCoordinateSubscription: Subscription;
  mapCodeSubscription: Subscription;
  map_id: string | number = '';
  mapListSubscription: Subscription;
  fallbackToInvite: boolean = false;
  autoInviteId: string = '';
  isPlay: boolean = false;
  birthLocationKeys = ['culture', 'religion', 'city', 'state', 'province'];
  returnToContentCreation: boolean | undefined | string = false;
  contentCreationBackUrl: string | null = null;
  contentCreationCoordinates: string | null = null;
  contentCreationCityCode: string | null = null;
  contentCreationMapCode: string | null = null;
  preSelectedGameSystem: string | null = null;
  mordern_ethnicity_list: string[];

  constructor(
    private formBuilder: FormBuilder,
    public activeroute: ActivatedRoute,
    private dataserv: DataService,
    private router: Router,
    private modalService: NgbModal,
    private cityMapService: CityMapService,
    private mapService: MapService,
    private location: Location,
    private toastService: ToastService,
    private coordinateService: CoordinatesService,
    private currentUserService: CurrentUserService,
    private mapDataService: MapDataService,
    private wikiService: WikiService,
    private cdr: ChangeDetectorRef
  ) {
    this.isClassAdded = true;
  }

  getForm() {
    return this.playerdetailform;
  }

  ngOnDestroy(): void {
    this.mapService.removeOldMap();
    this.coordSubscription?.unsubscribe();
    this.cityMapVisibleSubscription?.unsubscribe();
    this.mapService.removeCityLayer();
    this.playerOuterCoordinateSubscription?.unsubscribe();
    this.mapCodeSubscription?.unsubscribe();
    this.mapListSubscription?.unsubscribe();
    this.mapService.unbindSingleClick();
    layerlist.forEach((layer) => {
      if (layer.label == 'Culture') {
        layer.checked = false;
        layer.visible = false;
      } else if (layer.label == 'State') {
        layer.checked = true;
        layer.visible = true;
      }
    });
  }

  intializeCoordsSubscription() {
    this.coordSubscription = this.coordinateService.pointDrawn$.subscribe(
      (data) => {
        if (data) {
          this.coords = data;
          if (data[0] == null || data[1] == null) return; // 0 is a real coordinate (the map's centre line)
          const coords: { latitude: number; longitude: number } = {
            latitude: data[1],
            longitude: data[0],
          };
          this.mapDataService
            .getMapData(this.map_code, coords)
            .subscribe((res: any) => {
              if (res.features?.length > 0) {
                const features = res.features;
                const featuresProperties = features.map(
                  (feature) => feature.properties,
                );
                const merged = featuresProperties.reduce(
                  (acc, curr) => ({ ...acc, ...curr }),
                  {},
                );
                const state = merged.state_full_name ?? '';
                const province = merged.province_full_name ?? '';
                // fallback if not present
                const culture = merged.culture_name ?? '';
                const religion = merged.religion_name ?? '';
                const city = merged.cell_has_burgs ? merged.burg_burg : '';

                // Constructing a single string, joining non-empty parts

                this.birthLocation.city = city;
                this.birthLocation.state = state;
                this.birthLocation.province = province;
                this.birthLocation.culture = culture;
                this.birthLocation.religion = religion;
                this.playerdetailform.patchValue({
                  birth_place: this.birthLocation,
                });
                this.cdr.detectChanges(); // show the place name
              }
            });

          this.playerdetailform
            .get('geography')
            ?.setValue(this.coords?.join(','));
          // The app doesn't redraw on its own after a map click; without this
          // Accept stayed grey until something else happened to redraw.
          this.cdr.detectChanges();
        }
      },
    );
    this.playerOuterCoordinateSubscription =
      this.coordinateService.playerOuterCoordinates$.subscribe((data) => {
        if (data) {
          this.playerdetailform
            .get('last_map_location')
            ?.setValue(data?.join(','));
        }
      });
  }

  backcity() {
    this.cityMapService.setCityMapVisiblity({ visible: false, code: null });
  }

  private intializeCityVisibleSubscription() {
    this.cityMapVisibleSubscription =
      this.cityMapService.cityMapVisible$.subscribe((value: any) => {
        if (value && value.visible === true && !this.acceptbtn) {
          this.cityClick = true;
          this.playerdetailform.get('geography').setValue('');
          this.mapService.navigateToCityFlag = false;
          this.mapService.map1.setTarget(this.cityMap.nativeElement);
          this.mapService.citydataload(
            value.code,
            this.map_code,
            false,
            false,
            false,
            this.game_id,
          );
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
          }, 0);
          this.mapService.cityMapBirthLocation(
            this.uploadedimage?.cropped_image,
          );
          this.mapService.map1.updateSize();
          this.coordSubscription?.unsubscribe();
          this.coordSubscription = null;
        } else {
          if (this.cityClick) {
            this.cityClick = false;
            if (!this.coordSubscription) this.intializeCoordsSubscription();
            this.mapService.removeCityLayer();
            this.playerdetailform.get('last_map_location').setValue('');
          }
        }
        if (!this.acceptbtn) {
          this.playerdetailform.patchValue(
            {
              city_id: value.code,
            },
            { emitEvent: false },
          );
        }
      });

    this.cityMapService.cityMapCoordinates$.subscribe((value: any) => {
      if (value) {
        const coords = value.join(',');
        this.playerdetailform.get('geography')?.setValue(coords);
        this.cdr.detectChanges(); // enable Accept right away (see above)
      }
    });
  }

  private processPreSelectionOfMap(params: any) {
    if (params['map_code'] && this.mode === 'create' && this.playerLevel) {
      this.playerdetailform
        ?.get('primary_class_level')
        .setValue(this.playerLevel);
      this.playerdetailform?.get('map_code').setValue(this.map_code);
      this.playerdetailform.get('primary_class_level').disable();
    }
    if (this.contentCreationMapCode) {
      this.playerdetailform
        .get('map_code')
        .setValue(this.contentCreationMapCode);
      this.playerdetailform.get('map_code').disable();
    }
    if (this.autoInviteId) {
      this.playerdetailform.get('map_code').disable();
    }
  }

  private handleGeographyChange(value: string, is_city: boolean): void {
    const profileImage =
      this.playerdata?.cropped_image || this.uploadedimage?.cropped_image;
    if (profileImage) {
      this.mapService.userProfileUrl = profileImage;
    }
    this.coords = value.split(',').map((item) => item.trim()); // trim to clean up any extra spaces
    if (!is_city) {
      this.mapService.addStaticPointPlayerDetailView(
        this.coords,
        profileImage,
      );
    } else {
      this.mapService.layerContentPinLayer?.getSource()?.clear();
      if (this.playerdetailform.get('last_map_location').value) {
        this.mapService.addStaticPointPlayerDetailView(
          this.playerdetailform
            .get('last_map_location')
            ?.value?.split(',')
            .map((item) => item.trim()),
          profileImage,
        );
      }
      if (this.playerdetailform.get('city_id')?.value) {
        this.cityClick = true;
        this.mapService.map1?.setTarget(this.cityMap.nativeElement);
        this.mapService.navigateToCityFlag = false;
        this.mapService.userProfileUrl = profileImage;
        this.mapService.citydataload(
          this.playerdetailform.get('city_id')?.value,
          this.map_code,
          false,
          false,
          false,
          this.game_id,
        );
        this.mapService.map1?.updateSize();
        setTimeout(() => {
          window.dispatchEvent(new Event('resize')); // Simulate window resize
        }, 300);
      }
      this.mapService.addCityStaticPoint(
        this.coords,
        profileImage,
      );
    }
  }

  ngOnInit(): void {
    this.gameproductlist();

    this.activePath = localStorage.getItem('activePath');

    this.initializeForm();

    combineLatest([
      this.currentUserService.currentUser.pipe(filter(Boolean), take(1)),
      this.activeroute.queryParams.pipe(take(1)),
    ])
      .pipe(
        tap(([user, params]) => this.extractParams(user, params)),
        switchMap(() => this.mapService.mapList$),
        tap((mapList) => this.handleMapList(mapList)),
      )
      .subscribe(() => {
        this.cdr.detectChanges();
      });

    // Not marking every field as touched here any more: required fields
    // always show their * now, and a field turns red only after the person
    // has been in it and left it empty (it made a fresh form all red).
    this.cdr.detectChanges();
  }

  private extractParams(user: any, params: any): void {
    this.user_id = Number(user.id);
    this.playerdetailform.get('user_id').setValue(this.user_id);
    this.mode = params['mode'];
    if (params['isPlay']) {
      this.isPlay = params['isPlay'] === 'true';
    }
    this.playerLevel = params['playerLevel'];
    this.preSelectedGameSystem = params['game_system'];
    this.fallbackToInvite = params['fallbackToInvite'] === 'true';
    this.autoInviteId = params['autoInviteId'];

    this.map_code = params['map_code'];
    this.returnToContentCreation = params['returnToContentCreation'];
    this.contentCreationBackUrl = params['backUrl'];
    this.contentCreationCoordinates = params['coordinates'];
    this.contentCreationCityCode = params['contentCityCode'];
    this.contentCreationMapCode = params['contentMapCode'];

    this.playerId = Number(this.activeroute.snapshot.paramMap.get('player_id'));

    if (this.mode === 'edit') {
      this.getCharacterDetails();
    }
  }

  private handleMapList(mapList: any): void {
    if (!mapList) {
      this.mapService.getMapList();
      return;
    }

    this.mapListData = mapList;

    // Set default map if needed (logic moved from setTimeout)
    if (
      this.mode !== 'edit' &&
      !this.map_code &&
      this.mapListData?.length > 0 &&
      !this.contentCreationMapCode
    ) {
      this.map_code = this.mapListData[0]?.map_id;
    }

    this.processPreSelectionOfMap({
      map_code: this.map_code,
    });

    // Ensure form control has value if map_code is set
    const mapCodeControl = this.playerdetailform?.get('map_code');
    if (this.map_code && mapCodeControl && (!mapCodeControl.value || mapCodeControl.value === '')) {
      mapCodeControl.setValue(this.map_code);
    }
  }

  ngAfterViewInit(): void {
    this.restorePlanUsage();
    this.configureLayers();


    this.bindMapCodeChanges();

    if (!this.mode || this.mode === 'create') {
      this.intializeCityVisibleSubscription();
      this.intializeCoordsSubscription();
    }
  }

  private bindMapCodeChanges(): void {
    const mapCodeControl = this.playerdetailform.get('map_code');

    this.mapCodeSubscription = mapCodeControl.valueChanges
      .pipe(
        startWith(mapCodeControl.value),
        debounceTime(300), // Add debounce to prevent rapid updates
        distinctUntilChanged(),
      )
      .subscribe((value) => {
        if (!value || value === '' || this.acceptbtn) return;

        this.map_code = value;
        this.resetBirthLocationIfCreate();
        this.loadMap();
      });
  }

  private loadMap(): void {
    this.mapService.map.setTarget(null);
    this.mapService.removeOldMap();
    this.mapService.map.setTarget(this.mapElement.nativeElement);

    this.mapService.unbindSingleClick();

    this.mapService.loadlayers({
      map_id: this.map_code,
      type: 'Master',
      isFitExtent: true,
    });

    if (this.mode !== 'edit') {
      this.mapService.bindSingleClick();
      const profileImage =
        this.uploadedimage?.cropped_image || this.playerdata?.cropped_image;
      this.mapService.intializeMainMapBirthLocation(profileImage);
    }

    if (this.mode === 'edit') {
      this.mapService.unbindSingleClick();
      const geographyControl = this.playerdetailform.get('geography');
      const cityIDControl = this.playerdetailform.get('city_id');

      if (geographyControl?.value) {
        // If value already exists
        this.handleGeographyChange(
          geographyControl.value,
          cityIDControl.value.length > 1,
        );
      }

      // Listen for changes
      geographyControl?.valueChanges.pipe(startWith(geographyControl.value)).subscribe((value: string) => {
        if (value) {
          this.handleGeographyChange(value, cityIDControl.value.length > 1);
        }
      });

      setTimeout(() => {

        cityIDControl?.valueChanges.pipe(startWith(cityIDControl.value)).subscribe((value: string) => {
          if (value) {
            this.handleGeographyChange(geographyControl.value, value.length > 1);
          }
        });
      }, 1000);





    }
  }
  private resetBirthLocationIfCreate(): void {
    if (!this.mode || this.mode === 'create') {
      this.birthLocation = {
        culture: '',
        religion: '',
        province: '',
        city: '',
        state: '',
      };
      this.cityClick = false;
    }
  }


  private restorePlanUsage(): void {
    const planUsage = sessionStorage.getItem('planUsage');

    if (planUsage) {
      this.planUsage = JSON.parse(planUsage);
    }
  }

  private configureLayers(): void {
    this.newLayers = layerlist.filter((lyr) => lyr.toggle == true);

    this.newLayers.forEach((layer) => {
      if (layer.label === 'Culture') {
        layer.checked = true;
      } else if (layer.label === 'State') {
        layer.checked = false;
      } else {
        layer.checked = false;
      }
    });

    this.mapService.filterAndToggleLayers(this.newLayers);
  }

  getCharacterDetails() {
    this.dataserv
      .Getcharacterdetailbychar_id(this.playerId)
      .subscribe((res: any) => {
        if (res) {
          this.playerdata = res.character_details;
              this.game_details = this.playerdata.game_details[0];
              this.cdr.detectChanges();

          this.game_id = this.game_details?.game_id;
          if (this.playerdata.regular_image) {
            const imageUrl =
              ip + this.playerdata.regular_image
                ? ip + this.playerdata.regular_image
                : null;
            this.urlToBase64(imageUrl)
              .then((base64String) => {
                this.base64Regular = base64String;
                const { regular_image } = this.playerdetailform.controls;

                regular_image.setValue(
                  this.uploadedimage
                    ? this.uploadedimage.regular_image
                    : this.base64Regular || '',
                );
                // Use the base64 string as needed
              })
              .catch((error) => {
                console.error('Error converting URL to base64:', error);
              });
            const croppedImageUrl =
              ip + this.playerdata.cropped_image
                ? ip + this.playerdata.cropped_image
                : null;
            this.urlToBase64(croppedImageUrl).then((base64String) => {
              this.base64Cropped = base64String;
              const { cropped_image } = this.playerdetailform.controls;

              cropped_image.setValue(
                this.uploadedimage
                  ? this.uploadedimage.cropped_image
                  : this.base64Cropped || '',
              );
              // Use the base64 string as needed
            });
          }
          this.setFormControlValues(this.playerdata);
          if (this.isPlay) {
            this.navigateToPlay(this.playerdata);
          }
        }
      });
  }

  generateRegeneratePortrait() {
    const modalRef = this.modalService.open(AiGenerationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.playerDetails = this.playerdetailform.value;
    if (this.playerdata) {
      modalRef.componentInstance.isFirst = this.playerdata.id;
    } else modalRef.componentInstance.isFirst = 'first_upload';

    modalRef.componentInstance.char_id = this.playerId;
    modalRef.componentInstance.modalTitle = 'Image'
    modalRef.componentInstance.userId = this.user_id;
    modalRef.componentInstance.tokenCost = 10;
    modalRef.componentInstance.uploadedimage = this.uploadedimage;
    modalRef.result.then((result) => {
      if (result?.regular_image) {
        this.uploadedimage = result;
        this.playerdetailform
          .get('regular_image')
          .setValue(result.regular_image);
        this.playerdetailform.updateValueAndValidity();
        this.updateMapTokenAfterImageUpload(result);
        if (!result.isFirstUpload) {
          this.dataserv
            .Getcharacterdetailbychar_id(this.playerId)
            .subscribe((res: any) => {
              this.playerdata = res.character_details;
              this.game_details = this.playerdata.game_details[0];

            });
        }
      }
    });
  }

  getmaplist(isParams: any) {
    this.mapService.getMapList(this.user_id, false);
    // The subscription in ngOnInit will handle updating mapListData
    // We just need to handle the initial logic if it was in the subscribe callback
  }

  urlToBase64(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = function (error) {
        reject(error);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  popover() {
    // Initialize Bootstrap popovers after the view has been initialized
    $(document).ready(function () {
      $('[data-toggle="popover"]').popover();
    });
  }

  initializeForm() {
    this.playerdetailform = this.formBuilder.group({
      // Required fields
      race: ['', [Validators.required]],
      primary_class: ['', [Validators.required]],
      primary_class_level: [1, [Validators.required]],
      strength: [12, [Validators.required, Validators.max(50)]],
      dexterity: [12, [Validators.required, Validators.max(50)]],
      constitution: [12, [Validators.required, Validators.max(50)]],
      wisdom: [12, [Validators.required, Validators.max(50)]],
      intelligence: [12, [Validators.required, Validators.max(50)]],
      charisma: [12, [Validators.required, Validators.max(50)]],
      birth_place: [''],
      alignment: ['', [Validators.required]],
      age: ['', [Validators.required]],
      sex: ['', [Validators.required]],
      height: ['', [Validators.required]],
      weight: ['', [Validators.required]],
      first_name: ['', [Validators.required]],
      last_name: [''],
      user_id: [this.user_id, [Validators.required]],
      nickname: ['', [Validators.required]],
      map_code: ['', [Validators.required]],
      geography: [null, [Validators.required]],

      // Optional fields that are used in the patch function
      secondary_class: ['', []],
      secondary_class_level: [1, []],
      choosen_alignment: ['', []],
      hair_color: ['', []],
      hair_style: ['', []],
      physical_attributes: ['', []],
      regular_image: ['', [Validators.required]],
      posture: ['', []],
      body_shape: ['', []],
      physical_build: ['', []],
      walking_gate: ['', []],
      eye_color: ['', []],
      facial_hair_style: ['', []],
      facial_hair_color: ['', []],
      skin_texture: ['', []],
      skin_color: ['', []],
      description: ['', []],

      // GAME DETAILS
      group: ['', []],
      game_master: ['', []],
      game_system: ['', []],
      map: ['', []],
      game_creator: [{ value: '', disabled: true }, []],
      next_game: ['', []],

      // Role-playing traits
      leaning_towards: ['', []],
      motivation: ['', []],
      inspiration: ['', []],
      loyalties: ['', []],
      guiding_principles: ['', []],

      // SOCIAL AND ECONOMICS FIELDS
      personal_social_status: ['', []],
      family_social_status: ['', []],
      personal_economic_status: ['', []],
      family_economic_status: ['', []],
      foundational_learning: ['', []],
      apprentice_training: ['', []],
      scholarly_studies: ['', []],
      guild_membership: ['', []],

      // ATTIRE FIELDS
      armor_color: ['', []],
      armor_description: ['', []],
      helmet_color: ['', []],
      helmet_description: ['', []],
      shield_color: ['', []],
      shield_description: ['', []],
      head_color: ['', []],
      head_description: ['', []],
      face_color: ['', []],
      face_description: ['', []],
      neck_color: ['', []],
      neck_description: ['', []],
      shoulder_color: ['', []],
      shoulder_description: ['', []],
      torso_color: ['', []],
      torso_description: ['', []],
      hands_color: ['', []],
      hands_description: ['', []],
      waist_color: ['', []],
      waist_description: ['', []],
      cropped_image: ['', []],
      legs_color: ['', []],
      legs_description: ['', []],
      feet_color: ['', []],
      feet_description: ['', []],
      back_color: ['', []],
      back_description: ['', []],
      accessories_color: ['', []],
      accessories_description: ['', []],
      cloak_color: ['', []],
      cloak_description: ['', []],
      hat_color: ['', []],
      hat_description: ['', []],
      primary_weapon_color: ['', []],
      primary_weapon_description: ['', []],
      secondary_weapon_color: ['', []],
      secondary_weapon_description: ['', []],
      backstory: ['', []],
      city_id: [''],
      modern_ethnicity: [[], []],
      last_map_location: [''],

      // Array fields for dynamic rows
      pets: this.formBuilder.array([this.createPetRow()]),
      body_modifications: this.formBuilder.array([
        this.createBodyModificationsRow(),
      ]),
    });

    this.playerdetailform.get('alignment').valueChanges.subscribe((value) => {
      const secondValue =
        this.playerdetailform.get('leaning_towards')?.value || ''; // Get second control's value
      this.updateFormAndFilter(value, secondValue);
    });

    this.playerdetailform
      .get('leaning_towards')
      .valueChanges.subscribe((value) => {
        const firstValue = this.playerdetailform.get('alignment')?.value || ''; // Get first control's value
        this.updateFormAndFilter(firstValue, value);
      });
    const disableKeys = [
      'choosen_alignement',
      'next_game',
      'game_system',
      'game_master',
      'map',
      'group',
    ];
    disableKeys.forEach((key) => {
      if (this.playerdetailform.get(key)) {
        this.playerdetailform.get(key).disable();
      }
    });
  }

  updateFormAndFilter(alignment: string, secondaryAlignment: string) {
    this.playerdetailform.patchValue(
      {
        alignment: alignment,
        leaning_towards: secondaryAlignment,
      },
      { emitEvent: false }, // Avoid infinite loop
    );

    const combinedValues = new Set<string>();
    if (alignment) combinedValues.add(alignment.toLowerCase());
    if (secondaryAlignment && secondaryAlignment !== alignment)
      combinedValues.add(secondaryAlignment.toLowerCase());

    this.processChildGroups(Array.from(combinedValues)); // Convert Set to Array
  }

  processChildGroups(values: string[]) {
    this.filter_motivation =
      this.motivation_list?.filter((x: any) =>
        values.includes(x.label.toLowerCase()),
      ) || [];
    this.filter_inspiration =
      this.inspiration_list?.filter((x: any) =>
        values.includes(x.label.toLowerCase()),
      ) || [];
    this.filter_guiding_principles =
      this.guiding_principle_list?.filter((x: any) =>
        values.includes(x.label.toLowerCase()),
      ) || [];
    this.filter_loyalties =
      this.loyalty_list?.filter((x: any) =>
        values.includes(x.label.toLowerCase()),
      ) || [];
  }

  createPetRow(): FormGroup {
    return this.formBuilder.group({
      type: [''],
      color: [''],
      name: ['', [Validators.max(16)]],
      description: [''],
    });
  }

  createBodyModificationsRow(): FormGroup {
    return this.formBuilder.group({
      type: [''],
      color: [''],
      description: [''],
    });
  }

  createScarsRow(): FormGroup {
    return this.formBuilder.group({
      color: [''],
      description: [''],
    });
  }

  createPiercingRow(): FormGroup {
    return this.formBuilder.group({
      color: [''],
      description: [''],
    });
  }

  get bodyModificationsRows(): FormArray {
    return this.playerdetailform.get('body_modifications') as FormArray;
  }

  get petRows(): FormArray {
    return this.playerdetailform.get('pets') as FormArray;
  }

  addBodyModificationsRow() {
    if (this.bodyModificationsRows.length < this.maxRows) {
      this.bodyModificationsRows.push(this.createBodyModificationsRow());
    }
  }

  removeBodyModificationsRow(index: number) {
    if (index >= 0 && index < this.bodyModificationsRows.length) {
      this.bodyModificationsRows.removeAt(index);
    }
  }

  addPetRow() {
    if (this.petRows.length < this.maxRows) {
      this.petRows.push(this.createPetRow());
    }
  }

  removePetRow(index: number) {
    if (index >= 0 && index < this.petRows.length) {
      this.petRows.removeAt(index);
    }
  }

  setFormControlValues(data: any) {
    if (this.playerdetailform) {
      // Build a mapping object that aligns exactly with your reactive form keys.
      const formPatch = {
        race: data.race || '',
        primary_class: data.primary_class || '',
        primary_class_level: data.primary_class_level || 2,
        strength: data.strength || 12,
        dexterity: data.dexterity || 12,
        constitution: data.constitution || 12,
        wisdom: data.wisdom || 12,
        intelligence: data.intelligence || 12,
        charisma: data.charisma || 12,
        alignment: data.alignment || '',
        age: data.age || '',
        sex: data.sex || '',
        height: data.height || '',
        weight: data.weight || '',
        first_name: data.first_name || '',
        cropped_image: data.cropped_image || '',
        last_name: data.last_name || '',
        user_id: data.user_id || '',
        nickname: data.nickname || '',
        map_code: data.map_code || '',
        geography: data.current_location || '',

        secondary_class: data.secondary_class || '',
        secondary_class_level: data.secondary_class_level || 2,
        // Use the exact key names as defined in the form
        hair_color: data.hair_color || '',
        hair_style: data.hair_style || '',
        physical_attributes: data.physical_attributes || '',

        regular_image:
          data.regular_image !== undefined ? this.base64Regular : '',
        posture: data.posture || '',
        body_shape: data.body_shape || '',
        physical_build: data.physical_build || '',
        walking_gate: data.walking_gate || '',
        eye_color: data.eye_color || '',
        facial_hair_style: data.facial_hair_style || '',
        facial_hair_color: data.facial_hair_color || '',
        skin_texture: data.skin_texture || '',
        skin_color: data.skin_color || '',
        description: data.description || '',

        group: data.group || '',

        next_game: data.next_game || '',

        leaning_towards: data.leaning_towards || '',
        motivation: data.motivation || '',
        inspiration: data.inspiration || '',
        loyalties: data.loyalties || '',
        guiding_principles: data.guiding_principles || '',

        personal_social_status: data.personal_social_status || '',
        family_social_status: data.family_social_status || '',
        personal_economic_status: data.personal_economic_status || '',
        family_economic_status: data.family_economic_status || '',
        foundational_learning: data.foundational_learning || '',
        apprentice_training: data.apprentice_training || '',
        scholarly_studies: data.scholarly_studies || '',
        guild_membership: data.guild_membership || '',

        armor_color: data.armor_color || '',
        armor_description: data.armor_description || '',
        helmet_color: data.helmet_color || '',
        helmet_description: data.helmet_description || '',
        shield_color: data.shield_color || '',
        shield_description: data.shield_description || '',
        head_color: data.head_color || '',
        head_description: data.head_description || '',
        face_color: data.face_color || '',
        face_description: data.face_description || '',
        neck_color: data.neck_color || '',
        neck_description: data.neck_description || '',
        birth_place: data.birth_place || 'Unknown (old data)',

        shoulder_color: data.shoulder_color || '',
        shoulder_description: data.shoulder_description || '',
        torso_color: data.torso_color || '',
        torso_description: data.torso_description || '',
        hands_color: data.hands_color || '',
        hands_description: data.hands_description || '',
        waist_color: data.waist_color || '',
        waist_description: data.waist_description || '',
        legs_color: data.legs_color || '',
        legs_description: data.legs_description || '',
        feet_color: data.feet_color || '',
        feet_description: data.feet_description || '',
        back_color: data.back_color || '',
        back_description: data.back_description || '',
        accessories_color: data.accessories_color || '',
        accessories_description: data.accessories_description || '',
        cloak_color: data.cloak_color || '',
        cloak_description: data.cloak_description || '',
        hat_color: data.hat_color || '',
        hat_description: data.hat_description || '',
        primary_weapon_color: data.primary_weapon_color || '',
        primary_weapon_description: data.primary_weapon_description || '',
        secondary_weapon_color: data.secondary_weapon_color || '',
        secondary_weapon_description: data.secondary_weapon_description || '',
        backstory: data.backstory || '',
        city_id: data.city_id || '',
        modern_ethnicity: data.modern_ethnicity || '',
        last_map_location: data.last_map_location || '',

        // Handle array fields with helper methods as needed
        pets: data.pets ? this.setPetsArray(data.pets) : [],
        body_modifications: data.body_modifications
          ? this.setBodyModificationRow(data.body_modifications)
          : [],
      };
      const game_details =
        data.game_details && data.game_details.length > 0
          ? data.game_details[0]
          : null;
      let obj;

      if (game_details) {
        obj = {
          game_system: game_details.game_system,
          game_master: game_details.game_master_name,
          map: game_details.map_name,
          group: game_details.game_name,
          game_creator: game_details.game_creator || '',
        };
      }
      if (formPatch.birth_place) {
        this.birthLocation = formPatch.birth_place;
      }

      this.playerdetailform.patchValue({ ...formPatch, ...obj });

      if (this.mode === 'edit') {
        this.playerdetailform.controls['map_code'].disable();
        this.listofRemoveCharacters = [data?.id];
      }
    } else {
      console.error('Form group is not initialized');
    }
  }

  setPetsArray(pets: any[]) {
    const petsFormArray = this.petRows;
    petsFormArray.clear(); // Clear existing pet rows before adding new ones

    pets.forEach((pet) => {
      petsFormArray.push(
        this.formBuilder.group({
          type: [pet.type || ''],
          color: [pet.color || ''],
          name: [pet.name || ''],
          description: [pet.description || ''],
        }),
      );
    });
  }

  setBodyModificationRow(body_modifications: any[]) {
    const bodyModificationsArray = this.bodyModificationsRows;
    bodyModificationsArray.clear(); // Clear existing pet rows before adding new ones

    body_modifications.forEach((body_modification) => {
      bodyModificationsArray.push(
        this.formBuilder.group({
          type: [body_modification.type || ''],
          color: [body_modification.color || ''],
          description: [body_modification.description || ''],
        }),
      );
    });
  }

  // setPiercingArray(piercings: any[]) {
  //   const piercingsFormArray = this.piercingRows;
  //   piercingsFormArray.clear(); // Clear existing pet rows before adding new ones

  //   piercings.forEach((piercing) => {
  //     piercingsFormArray.push(
  //       this.formBuilder.group({
  //         color: [piercing.color || ''],
  //         description: [piercing.description || ''],
  //       })
  //     );
  //   });
  // }

  // setScarsArray(scars: any[]) {
  //   const scarsFormArray = this.scarsRows;
  //   scarsFormArray.clear(); // Clear existing pet rows before adding new ones

  //   scars.forEach((scar) => {
  //     scarsFormArray.push(
  //       this.formBuilder.group({
  //         color: [scar.color || ''],
  //         description: [scar.description || ''],
  //       })
  //     );
  //   })
  // }

  getFormattedRequiredFields() {
    return this.requiredFields
      .map((field) => this.staticFieldLabels[field])
      .join(',');
  }

  saveChanges(): Observable<boolean> {
    return this.submitOnlyObservables();
  }

  submitOnlyObservables(): Observable<boolean> {
    this.showRequiredFields = false;
    this.requiredFields = [];
    this.creating = true;

    if (this.playerdetailform.invalid) {
      this.showRequiredFields = true;
      for (const field in this.playerdetailform.controls) {
        if (this.playerdetailform.get(field)?.errors?.['required']) {
          this.requiredFields.push(field);
        }
      }
      return of(false); // Form invalid, return false Observable
    }

    const { regular_image, cropped_image } =
      this.playerdetailform.controls;
    regular_image.setValue(
      this.uploadedimage
        ? this.uploadedimage.regular_image
        : this.base64Regular || '',
    );
    cropped_image.setValue(
      this.uploadedimage
        ? this.uploadedimage.cropped_image
        : this.base64Cropped || '',
    );

    const arrDelete = [
      'game_system',
      'game_master',
      'map',
      'group',
      'choosen_alignment',
    ];
    const formValue = { ...this.playerdetailform.getRawValue() };
    for (const key of arrDelete) {
      delete formValue[key];
    }

    const data = {
      ...formValue,
      user_id: this.user_id,
    };

    const apiCall =
      this.mode === 'edit'
        ? this.dataserv.updatecharacterdetail(this.playerId, {
          ...data,
          status: 'ACCEPTED',
        })
        : this.dataserv.createcharacterdetail({ ...data });

    return apiCall.pipe(
      map((res: any) => {
        this.toastService.showSuccess(
          `Character ${this.mode === 'edit' ? 'Updated' : 'Created'
          } Successfully !!!`,
          'success',
        );
        this.creating = false;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.playerdetailform.markAsPristine();
        this.playerdetailform.markAsUntouched();
        this.playerdetailform.updateValueAndValidity();
        this.requiredFields = [];

        // Check if we need to return to content creation
        this.activeroute.queryParams
          .subscribe((params) => {
            const returnToContentCreation = params['returnToContentCreation'];
            if (returnToContentCreation === 'true' && this.mode === 'create') {
              // Navigate back to content creation with the new character ID
              this.router.navigate(['/add-edit-content'], {
                queryParams: {
                  newCharacterId: res.id,
                  backwordNavigate: this.contentCreationBackUrl,
                  coordinates: this.contentCreationCoordinates,
                  citycode: this.contentCreationCityCode || null,
                  map_id: this.contentCreationMapCode,
                },
              });
            } else if (!this.fallbackToInvite) {
              this.router.navigate(['/char-portfolio']);
            } else {
              this.router.navigate(['/invitationpage'], {
                queryParams: {
                  autoInviteId: this.autoInviteId,
                  character_id: res.id,
                },
              });
            }
          })
          .unsubscribe();

        const targetMapId = this.map_code || this.playerdata?.map_code || this.playerdetailform?.get('map_code')?.value;
        if (targetMapId) {
          try {
            sessionStorage.setItem('activeWikiMapId', String(targetMapId));
            localStorage.setItem('activeWikiMapId', String(targetMapId));
          } catch (e) {}
        }
        WikiApiService.clearCache();

        return true; // Save succeeded
      }),
      catchError((error) => {
        this.toastService.showSuccess('Something went wrong. Please try again.', 'danger');
        this.creating = false;
        return of(false); // Save failed
      }),
    );
  }

  onSave(): void {
    this.submitOnlyObservables().subscribe({
      next: (success) => {
        if (success) {
          // Navigation and toast are already handled in submitObservable
        } else {
        }
      },
      error: (error) => {
        console.error('Error during save', error);
      },
    });
  }
  openWikiPage() {
    const { map_name, map_id } = this.processMapName(this.mode);
    const targetMapId = map_id || this.playerdata?.map_code || this.playerdetailform?.get('map_code')?.value;
    const nickname = this.playerdata?.nickname || this.playerdetailform?.get('nickname')?.value;
    if (targetMapId) {
      try {
        sessionStorage.setItem('activeWikiMapId', String(targetMapId));
        localStorage.setItem('activeWikiMapId', String(targetMapId));
      } catch (e) {}
    }
    if (targetMapId && nickname) {
      this.wikiService.openWiki('character', nickname, targetMapId, map_name);
    }
  }

  leaveParty(isAllDisband: boolean) {
    const deletemodalRef = this.modalService.open(
      DeleteGameAndCharacterModalComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      },
    );
    deletemodalRef.componentInstance.game_id = this.game_id;
    deletemodalRef.componentInstance.character_ids =
      this.listofRemoveCharacters;
    deletemodalRef.componentInstance.isAllDisband = isAllDisband;

    deletemodalRef.result.then((res) => {
      if (res) {
        this.getCharacterDetails();
      }
    });
  }
  retireCharacter() {
    if (
      this.planUsage.subscription_features.max_retired_npcs >=
      this.planUsage.usage.retired_npcs_created
    ) {
      const modalRef = this.modalService.open(RetirecharacterComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
      });

      modalRef.componentInstance.character_id = this.playerId;
      modalRef.componentInstance.game_id = this.game_id;
      modalRef.result.then((result) => {
        if (result) {
          this.router.navigate(['char-portfolio']);
        }
      });
    } else {
      const modalRef = this.modalService.open(
        InviteConfirmationModalComponent,
        {
          size: 'md',
          backdrop: 'static',
          centered: true,
        },
      );

      modalRef.componentInstance.isRetiredContent = true;
      modalRef.componentInstance.ishaveCharQuota = false;
    }
  }

  //get product lists
  gameproductlist() {
    this.dataserv.getproductlist('characterdetail').subscribe((data: any) => {
      const products = data.products;
      this.productlist = products.characterdetail;

      if (this.productlist?.length > 0) {
        this.sexualorientation_list = this.productlist
          .filter((x: any) => x.type === 'sexualorientation')
          .map((x: any) => ({
            type: x.type,
            value: x.value?.trim(),
          }));
        const raceList = this.productlist.filter((x: any) => x.type === 'race');
        this.raceList = this.processGroups(raceList);
        this.alignmentlist = this.productlist.filter(
          (x: any) => x.type === 'alignment',
        );
        const hairList = this.productlist.filter(
          (x: any) => x.type === 'hair_style',
        );
        this.hairList = this.processGroups(hairList);

        const primary_class_list = this.productlist.filter(
          (x: any) => x.type === 'class',
        );
        this.primary_class_list = this.processGroups(primary_class_list);
        this.facial_hair_list = this.productlist.filter(
          (x: any) => x.type === 'facial_hair_style',
        );
        this.postures = this.productlist.filter(
          (x: any) => x.type === 'posture',
        );
        this.body_shapes = this.productlist.filter(
          (x: any) => x.type === 'body_shape',
        );
        this.walking_gate_list = this.productlist.filter(
          (x: any) => x.type === 'walking_gate',
        );
        this.personal_social_status = this.productlist.filter(
          (x: any) => x.type === 'personal_social_status',
        );
        this.pet_familiar_mount_list = this.productlist.filter(
          (x: any) => x.type === 'familiar_pet_mount_dp',
        );
        this.personal_economic_status = this.productlist.filter(
          (x: any) => x.type === 'personal_economic_status',
        );
        this.foundational_learning = this.productlist.filter(
          (x: any) => x.type === 'foundation_learning',
        );
        this.apprentice_training = this.productlist.filter(
          (x: any) => x.type === 'apprentice_training',
        );
        this.scholarly_studies = this.productlist.filter(
          (x: any) => x.type === 'scholarly_studies',
        );
        this.guild_memberships = this.productlist.filter(
          (x: any) => x.type === 'guild_membership',
        );
        this.physical_list = this.productlist.filter(
          (x: any) => x.type === 'physical_build',
        );
        this.skin_texture_list = this.productlist.filter(
          (x: any) => x.type === 'skin_texture',
        );
        this.leaning_towards = this.productlist.filter(
          (x: any) => x.type === 'alignment',
        );
        this.mordern_ethnicity_list = this.productlist.filter(
          (x: any) => x.type === 'modern_ethnicity',
        );
        const motivation_list = this.productlist.filter(
          (x: any) => x.type === 'motivation',
        );
        this.motivation_list = this.processGroups(motivation_list);
        this.filter_motivation = this.motivation_list;

        const inspiration_list = this.productlist.filter(
          (x: any) => x.type === 'inspiration',
        );
        this.inspiration_list = this.processGroups(inspiration_list);
        this.filter_inspiration = this.inspiration_list;

        const loyalty_list = this.productlist.filter(
          (x: any) => x.type === 'loyalty',
        );
        this.loyalty_list = this.processGroups(loyalty_list);
        this.filter_loyalties = this.loyalty_list;

        const guiding_principle_list = this.productlist.filter(
          (x: any) => x.type === 'guiding_principle',
        );
        this.guiding_principle_list = this.processGroups(
          guiding_principle_list,
        );
        this.filter_guiding_principles = this.guiding_principle_list;
        this.cdr.detectChanges();
      }
    });
  }

  processGroups(list: any) {
    const groups: any[] = [];

    const groupMap: { [key: string]: any[] } = {};

    // Step 1: Group by "label"
    list.forEach((item: any) => {
      if (!groupMap[item.label]) {
        groupMap[item.label] = [];
      }
      groupMap[item.label].push({
        name: item.value,
        value: item.value, // you can map to a different value if needed
        detail: item.detail,
        sequence: item.sequence,
      });
    });

    // Step 2: Format as optionGroups array
    for (const label in groupMap) {
      groups.push({
        label: label,
        items: groupMap[label].sort((a, b) => a.sequence - b.sequence), // Optional: Sort by sequence
      });
    }

    return groups;
  }

  uploadPotrait(data: { regular_image: string }): void {
    const addmodalRef = this.modalService.open(
      CommonCharacterImageUploadModalComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      },
    );
    this.uploadedimage;
    // Pass any data to the modal if needed
    if (data?.regular_image && !data.regular_image?.includes('data:image')) {
      addmodalRef.componentInstance.selectedImage = ip + data.regular_image;
    } else if (
      data?.regular_image &&
      data.regular_image?.includes('data:image')
    ) {
      addmodalRef.componentInstance.selectedImage = data.regular_image;
    }
    if (this.playerdata) {
      addmodalRef.componentInstance.isFirst = this.playerdata.id;
    } else addmodalRef.componentInstance.isFirst = 'first_upload';

    addmodalRef.componentInstance.char_id = this.playerId;
    addmodalRef.componentInstance.aiGenerateModal = false;

    // Handle the modal result after it's closed
    addmodalRef.result
      .then((result) => {

        this.uploadedimage = result;
        this.playerdetailform
          .get('regular_image')
          .setValue(result.regular_image);
        this.playerdetailform.updateValueAndValidity();
        this.updateMapTokenAfterImageUpload(result);
        if (!result.isFirstUpload) {
          this.dataserv
            .Getcharacterdetailbychar_id(this.playerId)
            .subscribe((res: any) => {
              this.playerdata = res.character_details;
              this.game_details = this.playerdata.game_details[0];

              //
              // this.setFormControlValues(this.playerdata);
            });
        }
      })
      .catch((reason) => {
        // Handle case when the modal is closed without a result
      });
  }

  // base64ToImage(base64String: string): HTMLImageElement {

  //   this.selectedimage = new Image();
  //   this.selectedimage.src = base64String;
  //   return this.selectedimage;
  // }

  updateAgeLimit(): void {
    const ageControl = this.playerdetailform.get('age');
    const currentValue = ageControl.value;
    if (currentValue < 1) {
      ageControl.setValue(1);
    } else if (currentValue > 9999) {
      ageControl.setValue(9999);
    }
  }

  //for another fildes

  typenumberLimit(control: AbstractControl): void {
    const currentValue = control.value;

    if (currentValue < 3) {
      control.setValue(3);
    } else if (currentValue > 25) {
      control.setValue(25);
    }
  }

  magictypenumberLimit(control: AbstractControl): void {
    const currentValue = control.value;

    if (currentValue < 0) {
      control.setValue(0);
    } else if (currentValue > 10) {
      control.setValue(10);
    }
  }

  processErrorMessage(error: any): any { }

  opendeletemodel(name: string, data: any) {
    const deletemodalRef = this.modalService.open(
      CityEnterDeletemodelComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      },
    );

    deletemodalRef.componentInstance.pagename = 'Player';
    deletemodalRef.componentInstance.actionName = name;
    deletemodalRef.componentInstance.character_id = this.playerId;
    deletemodalRef.componentInstance.game_id = this.game_id;
    deletemodalRef.componentInstance.updateData.subscribe((res) => {
      if (res) {
        this.router.navigate(['/char-portfolio']);
      }
    });
    deletemodalRef.result.then((res) => {
      if (res?.role == 'game') {
        this.router.navigate(['/activegames']);
      }
    });
  }

  adjustStat(stat: string, change: number) {
    const control = this.playerdetailform.get(stat);
    if (!control) return;

    const currentValue = control.value || 0;
    const newValue = currentValue + change;

    if (newValue >= this.minValue && newValue <= this.maxValue) {
      control.setValue(newValue);
      control.markAsDirty(); // Mark as dirty programmatically
    }
  }

  // Increase methods
  increaseStrength() {
    this.adjustStat('strength', 1);
  }

  increaseDexterity() {
    this.adjustStat('dexterity', 1);
  }

  increaseConstitution() {
    this.adjustStat('constitution', 1);
  }

  increaseWisdom() {
    this.adjustStat('wisdom', 1);
  }

  increaseIntelligence() {
    this.adjustStat('intelligence', 1);
  }

  increaseCharisma() {
    this.adjustStat('charisma', 1);
  }

  // Decrease methods
  decreaseStrength() {
    this.adjustStat('strength', -1);
  }

  decreaseDexterity() {
    this.adjustStat('dexterity', -1);
  }

  decreaseConstitution() {
    this.adjustStat('constitution', -1);
  }

  decreaseWisdom() {
    this.adjustStat('wisdom', -1);
  }

  decreaseIntelligence() {
    this.adjustStat('intelligence', -1);
  }

  decreaseCharisma() {
    this.adjustStat('charisma', -1);
  }

  navigateToPlay(charDetails) {
    this.map_id = charDetails.map_code;
    this.game_id =
      charDetails.game_details.length > 0
        ? charDetails.game_details[0].game_id
        : undefined;
    // Get the date in "yyyy-mm-dd" format

    // Check if city_id exists and is greater than 0
    if (charDetails.city_id && charDetails.city_id.length > 0) {
      // Redirect to city-map-view
      this.router.navigate(
        [
          '/city-map-view/' +
          charDetails.city_id +
          '/' +
          this.map_id +
          '/' +
          (this.game_id ? this.game_id : 'null') +
          '/' +
          (charDetails.id ? charDetails.id : 'null'),
        ],
        {
          queryParams: {
            token: charDetails.cropped_image,
            isLoadToken: true,
            isPlaceToken: charDetails.current_location,
            backRoute: 'map-view-player',
            isMovable: !charDetails.game_details[0]?.is_active || false,
          },
        },
      );
    } else {
      // Use the existing map-view-player route
      this.router.navigate([
        '/map-view-player/' +
        this.map_id +
        '/' +
        this.game_id +
        '/' +
        charDetails.id,
      ]);
    }
  }

  filterlayers(layers: any) {
    this.newLayers = layers.filter((lyr) => lyr.toggle == true);
    return this.newLayers;
  }

  changeToggleLayer(item: any) {
    // each layer toggles independently, so a bare map plus any combination of
    // overlays can be shown at once, rather than exactly one at a time
    item.checked = !item.checked;
    this.mapService.filterAndToggleLayers(this.newLayers);
  }
  acceptCity() {
    this.acceptbtn = true;
    this.playerdetailform.get('map_code').disable();
    this.mapService?.map.removeInteraction(
      this.mapService?.mainDrawInteraction,
    );
    this.mapService.map1?.removeInteraction(
      this.mapService?.cityDrawInteraction,
    );
    this.mapService.unbindSingleClick();
  }

  triggerZoomIn(type: string) {
    if (type === 'map') {
      this.mapService?.zoomIn();
    } else {
      this.mapService?.zoomInCity();
    }
  }
  triggerZoomOut(type: string) {
    if (type === 'map') {
      this.mapService?.zoomOut();
    } else {
      this.mapService?.zoomOutCity();
    }
  }
  triggerTokenZoom(type: string) {
    if (type === 'map') {
      this.mapService?.zoomToExtent('map', this.mode);
    } else {
      this.mapService?.zoomToExtent('city-map');
    }
  }

  openBirthLocation(key: string, value: string) {
    const { map_name, map_id } = this.processMapName(this.mode);
    this.wikiService.openWiki(key, value, map_id, map_name);
  }

  processMapName(mode: boolean | string): {
    map_name: string | null;
    map_id: string | null;
  } {
    let mapcode = '';
    if (!mode || mode == 'create') {
      mapcode = this.playerdetailform.get('map_code')?.value;
      const mapName = this.mapListData?.find(
        (m) => m.map_id === mapcode,
      )?.map_name;

      return {
        map_name: mapName,
        map_id: mapcode,
      };
    } else {
      mapcode = this.playerdata?.map_code || '';
      const mapName = this.mapListData?.find(
        (m) => m.map_id === mapcode,
      )?.map_name;
      return {
        map_name: mapName,
        map_id: mapcode || null,
      };
    }
  }

  navigateToWikiWorld(map_name?: string, map_id?: string) {
    this.wikiService.openMapWiki(map_id, map_name);
  }

  downloadPlayerGuide(): void {
    const mapId = this.playerdata?.map_code || this.game_details?.map_id || this.map_code || this.playerdetailform?.get('map_code')?.value;
    if (!mapId) {
      this.toastService.showNote("We couldn't find this game's map.", 'warning');
      return;
    }
    this.dataserv.downloadFieldGuide(mapId).subscribe({
      next: (res: any) => {
        const blob = res.body;
        if (blob) {
          let filename = `Player_Guide_${mapId}.pdf`;
          const contentDisposition = res.headers.get('content-disposition');
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);
        }
      },
      error: (err: any) => {
        console.warn('Field guide download error:', err);
        this.toastService.showNote("The Player Guide isn't ready yet for this map.", 'warning');
      }
    });
  }

  navigateBack() {
    if (this.returnToContentCreation) {
      this.router.navigate(['/add-edit-content'], {
        queryParams: {
          isOnlyRestore: true,
          backwordNavigate: this.contentCreationBackUrl,
          coordinates: this.contentCreationCoordinates,
          citycode: this.contentCreationCityCode || null,
          map_id: this.contentCreationMapCode,
        },
      });
    } else {
      this.router.navigate(['/char-portfolio']);
    }
  }

  isFormValidExceptRegularImage(): boolean {
    return Object.entries(this.playerdetailform.controls).every(
      ([key, control]) => {
        // ignore this field
        if (key === 'regular_image') {
          return true;
        }

        // ignore disabled controls
        if (control.disabled) {
          return true;
        }

        // if field is required and has an error → fail
        if (control.hasError('required')) {
          return false;
        }

        return true;
      },
    );
  }

  generateDescription() {
    const modalRef = this.modalService.open(AiGenerationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      keyboard: false,
    });

    modalRef.componentInstance.playerDetails = this.playerdetailform.value;
    if (this.playerdata) {
      modalRef.componentInstance.isFirst = this.playerdata.id;
    } else {
      modalRef.componentInstance.isFirst = 'first_upload';
    }

    modalRef.componentInstance.char_id = this.playerId;
    modalRef.componentInstance.modalTitle = 'Description';
    modalRef.componentInstance.tokenCost = 5;
    modalRef.componentInstance.userId = this.user_id;
    modalRef.result
      .then((result) => {
        if (result && (result.character_description || result.description || result.grok_description || typeof result === 'string')) {
          const desc = typeof result === 'string' ? result : (result.character_description || result.description || result.grok_description);
          this.playerdetailform.get('description').setValue(desc);
          this.playerdetailform.updateValueAndValidity();
        }
      })
      .catch((error) => {
      });
  }

  generateBackstory() {
    const modalRef = this.modalService.open(AiGenerationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      keyboard: false,
    });

    modalRef.componentInstance.playerDetails = this.playerdetailform.value;
    if (this.playerdata) {
      modalRef.componentInstance.isFirst = this.playerdata.id;
    } else {
      modalRef.componentInstance.isFirst = 'first_upload';
    }

    modalRef.componentInstance.char_id = this.playerId;
    modalRef.componentInstance.modalTitle = 'Backstory';
    modalRef.componentInstance.tokenCost = 5;
    modalRef.componentInstance.userId = this.user_id;
    modalRef.result
      .then((result) => {
        if (result && (result.character_backstory || result.backstory || result.grok_backstory || typeof result === 'string')) {
          const backstory = typeof result === 'string' ? result : (result.character_backstory || result.backstory || result.grok_backstory);
          this.playerdetailform.get('backstory').setValue(backstory);
          this.playerdetailform.updateValueAndValidity();
        }
      })
      .catch((error) => {
      });
  }

  generateFullCharacter() {
    const modalRef = this.modalService.open(AiGenerationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      keyboard: false,
    });

    modalRef.componentInstance.playerDetails = this.playerdetailform.value;
    if (this.playerdata) {
      modalRef.componentInstance.isFirst = this.playerdata.id;
    } else {
      modalRef.componentInstance.isFirst = 'first_upload';
    }

    modalRef.componentInstance.char_id = this.playerId;
    modalRef.componentInstance.modalTitle = 'Full';
    modalRef.componentInstance.tokenCost = 18;
    modalRef.componentInstance.userId = this.user_id;
    modalRef.result
      .then((result) => {
        if (result) {
          // Handle Description
          if (result.character_description || result.description || result.grok_description) {
            const desc = result.character_description || result.description || result.grok_description;
            this.playerdetailform.get('description').setValue(desc);
          }
          // Handle Backstory
          if (result.character_backstory || result.backstory || result.grok_backstory) {
            const backstory = result.character_backstory || result.backstory || result.grok_backstory;
            this.playerdetailform.get('backstory').setValue(backstory);
          }
          // Handle Image
          if (result.regular_image) {
            this.uploadedimage = result;
            this.playerdetailform.get('regular_image').setValue(result.regular_image);
            this.updateMapTokenAfterImageUpload(result);
          }
          this.playerdetailform.updateValueAndValidity();
        }
      })
      .catch((error) => {
      });
  }

  private updateMapTokenAfterImageUpload(result: any): void {
    const croppedImage = result?.cropped_image || this.playerdata?.cropped_image;
    if (croppedImage) {
      this.mapService.userProfileUrl = croppedImage;
    }
    if (this.mode !== 'edit' && !this.acceptbtn) {
      this.mapService.intializeMainMapBirthLocation(croppedImage);
      if (this.cityClick) {
        this.mapService.cityMapBirthLocation(croppedImage);
      }
    } else {
      const geoValue = this.playerdetailform.get('geography')?.value;
      if (geoValue) {
        const cityIDControl = this.playerdetailform.get('city_id');
        this.handleGeographyChange(geoValue, cityIDControl?.value?.length > 1);
      }
    }
  }
}

// if something stop working then check this file
// ngOnInit(): void {
//   this.gameproductlist();
//   this.runQueryParamsExtraction();
// }

// private runQueryParamsExtraction() {
//   this.activePath = localStorage.getItem('activePath');
//   this.currentUserService.currentUser.subscribe((data) => {
//     if (data) {
//       this.activeroute.queryParams.subscribe((params) => {
//         this.user_id = Number(data.id);
//         this.mode = params['mode'];
//         if (params['isPlay']) {
//           this.isPlay = params['isPlay'] === 'true';
//         }
//         this.playerLevel = params['playerLevel'];
//         this.fallbackToInvite = params['fallbackToInvite'] === 'true';
//         this.autoInviteId = params['autoInviteId'];

//         this.playerId = Number(
//           this.activeroute.snapshot.paramMap.get('player_id'),
//         );
//         if (this.mode === 'edit') {
//           this.getCharacterDetails();
//         }
//       });
//     }
//   });

//   // Iterate through each form control and set its touched property to true
//   Object.keys(this.playerdetailform.controls).forEach((key) => {
//     this.playerdetailform.get(key).markAsTouched();
//   });
// }

// ngAfterViewInit(): void {
//   const planUsage = sessionStorage.getItem('planUsage');

//   if (planUsage) {
//     this.planUsage = JSON.parse(planUsage);
//   }
//   layerlist.forEach((layer) => {
//     if (layer.label == 'Culture') {
//       layer.checked = true;
//       layer.visible = true;
//     } else if (layer.label == 'State') {
//       layer.checked = false;
//       layer.visible = false;
//     }
//   });
//   if (this.contentCreationMapCode) {
//     this.playerdetailform
//       ?.get('map_code')
//       ?.setValue(this.contentCreationMapCode);
//   }
//   this.mapService.map.setTarget(this.mapElement.nativeElement);
//   this.mapCodeSubscription = this.playerdetailform
//     .get('map_code')
//     .valueChanges.subscribe((value) => {
//       if (this.acceptbtn) return;
//       this.map_code = value;
//       if (!this.mode || this.mode === 'create')
//         this.birthLocation = {
//           culture: '',
//           religion: '',
//           province: '',
//           city: '',
//           state: '',
//         };
//       this.cityClick = false;
//       //       this.mapService.removeOldMap();
//       this.mapService.unbindSingleClick();
//       this.mapService.loadlayers({
//         map_id: this.map_code,
//         type: 'Master',
//         isFitExtent: true,
//       });
//       if (this.mode !== 'edit') this.mapService.bindSingleClick();

//       if (!this.mode || this.mode === 'create')
//         this.mapService.intializeMainMapBirthLocation();
//
//         } else {
//         }
//       }

//       // Helper function
//     });
//   if (!this.mode || this.mode === 'create') {
//     this.intializeCityVisibleSubscription();
//     this.intializeCoordsSubscription();
//   }
// }
